<template>
    <sys-register-base
        :loading="loading"
        @onSave="save"
        :model.sync="model"
        :title="title"
        :icon="icon"
        v-bind:show.sync="dialog"
        maxWidth="70%"
    >
        <template v-slot:form>
            <v-tabs v-model="tab" class="mb-2">
                <v-tab>Dados</v-tab>
                <v-tab v-if="model.id">Menus</v-tab>
                <v-tab v-if="model.id">Autorizações</v-tab>
                <v-tab v-if="model.id">Dashboards</v-tab>
                <v-tab>Recursos</v-tab>
                <v-tab v-if="model.id">Usuários</v-tab>
            </v-tabs>

            <!-- Indica o perfil em edição (em todas as tabs, exceto Dados) -->
            <v-alert
                v-if="tab !== 0 && model && model.name"
                dense
                text
                color="indigo"
                border="left"
                icon="mdi-shield-account"
                class="mt-2 mb-2 text-body-2"
            >
                Você está configurando as opções do perfil <strong>{{ model.name }}</strong>.
            </v-alert>

            <v-tabs-items v-model="tab">

              <!-- DADOS -->
              <v-tab-item>
                <v-container fluid>

                    <v-alert dense text type="warning" border="left" class="mb-4" v-if="isAdminRole">
                        Perfil de <strong>administrador</strong>: os dados de identificação e permissões são fixos e não podem ser alterados.
                    </v-alert>

                    <!-- Identificação -->
                    <v-card outlined class="mb-4">
                        <v-card-title class="py-2 subtitle-2 grey--text text--darken-2">
                            <v-icon small color="grey darken-1" class="mr-2">mdi-card-account-details-outline</v-icon>
                            Identificação
                        </v-card-title>
                        <v-divider />
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="12" sm="5">
                                    <v-text-field autofocus :disabled="isAdminRole" :error="!!errors.name" :error-messages="errors.name" v-model="model.name" label="Nome*" hide-details="auto"></v-text-field>
                                </v-col>
                                <v-col cols="6" sm="3">
                                    <s-text-field code :disabled="isAdminRole" :error-messages="errors.code" v-model="model.code" label="Código" hide-details="auto"/>
                                </v-col>
                                <v-col cols="6" sm="2">
                                    <s-text-field :disabled="isAdminRole" :error-messages="errors.level" v-model="model.level" label="Nível" hide-details="auto"/>
                                </v-col>
                                <v-col cols="12" sm="2">
                                    <s-switch color="purple" inset :disabled="isAdminRole" v-model="model.active" label="Ativo"/>
                                </v-col>
                            </v-row>
                            <v-row>
                                <v-col cols="12">
                                    <v-textarea
                                        v-model="model.description"
                                        :disabled="isAdminRole"
                                        outlined
                                        name="input-7-4"
                                        label="Detalhes"
                                        :auto-grow="false"
                                        rows="2"
                                        hide-details
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                    <!-- Permissões do perfil -->
                    <v-card outlined>
                        <v-card-title class="py-2 subtitle-2 grey--text text--darken-2">
                            <v-icon small color="grey darken-1" class="mr-2">mdi-key-outline</v-icon>
                            Permissões do perfil
                        </v-card-title>
                        <v-divider />
                        <v-card-text class="pt-1">
                            <v-row>
                                <v-col cols="12" sm="6" v-for="perm in permissionSwitches" :key="perm.key" class="py-2">
                                    <s-switch inset hide-details :disabled="isAdminRole" v-model="model[perm.key]" :label="perm.label" class="ma-0 pa-0" />
                                    <div class="caption grey--text text--darken-1 mt-1">{{ perm.description }}</div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>

                </v-container>
              </v-tab-item>

              <!-- MENUS -->
              <v-tab-item v-if="model.id">
                <v-container fluid>
                    <v-alert dense text type="info" border="left" v-if="isAdminRole">
                        Perfil de <strong>administrador</strong>: tem acesso a <strong>todos os menus</strong>.
                    </v-alert>
                    <part-role-menus v-else v-model="model.menu" />
                </v-container>
              </v-tab-item>

              <!-- AUTORIZAÇÕES -->
              <v-tab-item v-if="model.id">
                <v-container fluid>
                    <v-alert dense text type="info" border="left" v-if="isAdminRole">
                        Perfil de <strong>administrador</strong>: tem <strong>todas as autorizações</strong>.
                    </v-alert>
                    <part-role-permissions v-else v-model="model.permission" />
                </v-container>
              </v-tab-item>

              <!-- DASHBOARDS -->
              <v-tab-item v-if="model.id">
                <v-container fluid>
                    <v-alert dense text type="info" border="left" v-if="isAdminRole">
                        Perfil de <strong>administrador</strong>: tem acesso a <strong>todos os dashboards</strong>.
                    </v-alert>
                    <part-role-charts v-else v-model="model.chart" />
                </v-container>
              </v-tab-item>

              <!-- RECURSOS -->
              <v-tab-item>
                <part-role-features :role="model" @change="featuresPayload = $event" />
              </v-tab-item>

              <!-- USUÁRIOS -->
              <v-tab-item v-if="model.id">
                <v-container fluid>
                    <part-role-users :role="model" />
                </v-container>
              </v-tab-item>

            </v-tabs-items>
            <!-- Alert para mensagens -->
            <emc-alert-snackbar :show="!! message.length"  :message="message" :color="error ? 'error' : 'success'"/>
        </template>
    </sys-register-base>
</template>
<script>

import { mapActions, mapState } from 'vuex'
import PartRoleFeatures from '@/modules/role/components/PartRoleFeatures.vue'
import PartRoleMenus from '@/modules/role/components/PartRoleMenus.vue'
import PartRolePermissions from '@/modules/role/components/PartRolePermissions.vue'
import PartRoleCharts from '@/modules/role/components/PartRoleCharts.vue'
import PartRoleUsers from '@/modules/role/components/PartRoleUsers.vue'
export default {
    name: "SysRegisterRole",
    components: { PartRoleFeatures, PartRoleMenus, PartRolePermissions, PartRoleCharts, PartRoleUsers },
    data: (vm) => ({
        dialog: false,
        error: false,
        errors: {},
        message: '',
        loading: false,
        tab: 0,
        featuresPayload: null,
        permissionSwitches: [
            { key: 'allow_change_time_table', label: 'Alterar Horário', description: 'Permite edição dos horários das aulas' },
            { key: 'allow_change_activities', label: 'Alterar Atividades', description: 'Permite edição das atividades extra classe' },
            { key: 'allow_lock_attribution', label: 'Bloqueio de Atribuição', description: 'Permite bloquear/desbloquear atribuições' },
            { key: 'hide_imports', label: 'Ocultar Importações', description: 'Oculta os ícones de importações no menu Importação' },
            { key: 'allow_edit_work_load', label: 'Editar CH Professor', description: 'Permite editar indicação/atividades com a folha fechada' },
            { key: 'allow_change_offer_item', label: 'Alterar Oferta', description: 'Permite alterações restritas no Planejamento de Oferta' },
            { key: 'allow_open_tickets', label: 'Abrir Chamados', description: 'Permite abrir chamados de suporte' },
        ],
    }),
    created(){

    },

    computed: {
      ...mapState('auth', ['acesso']),
      isAdminRole() {
          return !!(this.model && (this.model.is_admin || this.model.is_master));
      },
    },

    watch: {

        dialog(dialog_new, dialog_old) {

            if(dialog_new !== dialog_old) {
                this.$emit('update:show', dialog_new)
            }

        },

        show(show_new, show_old) {

            this.dialog = show_new;

            if(show_new){

                this.error = false;
                this.errors = {};
                this.tab = 0;
                this.featuresPayload = null;

                if(!this.model.id){
                    this.model.active = 1;
                    this.model.level = 0;
                } else {
                    // Garante arrays para os v-model de menus/permissões/dashboards
                    if(!Array.isArray(this.model.menu)) this.$set(this.model, 'menu', []);
                    if(!Array.isArray(this.model.permission)) this.$set(this.model, 'permission', []);
                    if(!Array.isArray(this.model.chart)) this.$set(this.model, 'chart', []);
                }

            }
        },

    },
    props: {
        model: {
            default: null
        },
        color: {
            type: String,
            default: 'grey lighten-5'
        },
        width: {
            type: String,
            default: "500"
        },
        maxWidth: {
            type: String,
            default: "80%"
        },
        icon: {
            type: String,
            default: "mdi-database-plus"
        },
        title: {
            type: String,
            default: "Perfil de Acesso"
        },
        text: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
    },
    methods:{
        ...mapActions('role', ['ActionUpdateRole', 'ActionCreateRole', 'ActionUpdateRoleMenu']),

        save(edit)
        {
            this.error = false;
            this.message = '';
            this.loading = true;

            // Só envia features se a aba Recursos foi aberta (evita apagar valores existentes sem querer)
            if(this.featuresPayload !== null) {
                this.model.features = this.featuresPayload;
            }

            if(edit) {

                // updateMenu persiste dados básicos + menus + permissões + dashboards + recursos
                Object.assign(this.model, { institution_id: this.acesso.instituicao.id });

                this.ActionUpdateRoleMenu(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted');
                })
                .catch((error) =>{
                    this.error      = true;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                     this.loading = false;
                })
            } else {
                this.ActionCreateRole(this.model)
                .then((res) => {
                    this.message = res.message;
                    this.$emit('onCompleted', res.data);
                })
                .catch((error) =>{
                    this.error      = error;
                    this.errors     = error.errors;
                    this.message    = error.message;
                })
                .finally(() => {
                   this.loading = false;
                })

            }
        },

    }
}
</script>
